// ** MUI Imports
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

// ** Custom Components Imports
import PageHeader from 'src/materio/@core/components/page-header'

// ** Demo Components Imports
import Table from 'src/features/roles/Table'
import RoleCards from 'src/features/roles/RoleCards'
import { useRef, useState } from 'react'
import RenderIf, { ClaimType, ClaimValue } from '../common/RenderIf'

const RolesComponent = () => {
    const [selectedRole, setSelectedRole] = useState({
        id: ''
    });
    

    const onSelectedRole = (roleId: string) => {
        setSelectedRole({
            id: roleId
        });        
    }

    return (
        
            <Grid container spacing={6}>
                <PageHeader
                    title={<Typography variant='h5'>Roles List</Typography>}
                    subtitle={
                        <Typography variant='body2'>
                            Please click a role to view all associated users.
                        </Typography>
                    }
                />
                <Grid item xs={12} sx={{ mb: 4 }}>
                    <RoleCards onRoleSelected={onSelectedRole} />
            </Grid>
            <RenderIf claimType={ClaimType.Roles} claimValue={ClaimValue.AssignUsersToRoles}>
                <PageHeader
                    title={<Typography variant='h5'>Total users with their roles</Typography>}
                    subtitle={
                        <Typography variant='body2'>
                            Users associated with the selected role.
                        </Typography>
                    }
                />
                <Grid item xs={12}>
                    <Table selectedRole={selectedRole} />
                </Grid>
            </RenderIf>
                
            </Grid>
        
    )
}

export default RolesComponent
